export default __webpack_public_path__ + "static/media/company-icon.6504935c.svg";